exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".react-components-NewProject-cabinetsSettings-index__crownMoldingsSelect--t72s_OuA0t {\n  margin-top: 10px;\n  width: 200px;\n}", ""]);

// Exports
exports.locals = {
	"crownMoldingsSelect": "react-components-NewProject-cabinetsSettings-index__crownMoldingsSelect--t72s_OuA0t"
};